define('lq/design/editors/dropExtensionsClicks',[
    'jquery',
    'underscore',
    'lq/drop',
    'lq/point',
    'lq/util',
    'lq/style',
    'lq/design/jqueryExtensions'
], function ($, _, Drop, Point, util, Style) {
	'use strict';

	var defaults = function () {
		return {
			$target: null,
		    drag: false,
		    revertWhenDroppedOffTarget: false,
		    getDropTargets: function () { return []; },
			dropToDrag: null,
			ignoreChildren: false,
			beforeDrag: function () {
			    this.saveTargets();
			    this.dropToDrag.$element.addClass('dragging');
			},
			afterDrag: function () {
			    this.dropToDrag.$element.removeClass('dragging');
			    this.highlightTargets(false);
			    var overlappingTargets = this.dropToDrag.getOverlappingDrops(this.targets);
			    if (overlappingTargets.length)
			        this.droppedOnTarget(overlappingTargets[0]);
			    else
			        this.droppedOffTarget();
			},
			dragFunc: function (newPos, drop, target, startPos, extraInfo) {
			    this.highlightTargets(true);
			    drop.dragToPosition(newPos);
			},
			saveTargets: function () {
			    this.targets = this.getDropTargets();
			},
			highlightTargets: function (state) {
			    var customState = state ? 'dragTarget' : null;
			    _.each(this.targets, function (targetDrop) {
			        Style.renderStyles(targetDrop, null, null, null, customState);
			    });
			    var overlappingTargets = this.dropToDrag.getOverlappingDrops(this.targets);
			    if (state && overlappingTargets.length)
			        Style.renderStyles(overlappingTargets[0], null, null, null, 'dragHover');
			},
			droppedOnTarget: function (targetDrop) { },
			droppedOffTarget: function () {
			    if (this.revertWhenDroppedOffTarget)
			        this.dropToDrag.animateBackToStart();
			},
            dragIgnoreOffset: false,
			click: $.noop,
			doubleClick: $.noop,
            snapGridSize: null
		};
	};

	var rectanglesOverlap = function (left1, top1, right1, bottom1, left2, top2, right2, bottom2) {
	    if (left1 > right2 || left2 > right1)
	        return false;
	    if (top1 > bottom2 || top2 > bottom1)
	        return false;
	    return true;
	};

	Drop.prototype.getOverlappingDrops = function (drops) {
	    var self = this;
	    var left = this.data.position.x;
	    var top = this.data.position.y;
	    var right = this.data.position.x + this.data.size.x;
	    var bottom = this.data.position.y + this.data.size.y;

	    return _.filter(drops, function (drop) {
	        return rectanglesOverlap(left, top, right, bottom,
                drop.data.position.x, drop.data.position.y, drop.data.position.x + drop.data.size.x, drop.data.position.y + drop.data.size.y);
	    });
	};

	Drop.prototype.animateBackToStart = function () {
	    var self = this;
	    if (self.initialPosition)
	        self.$element.animate({
	            left: self.initialPosition.x,
	            top: self.initialPosition.y
	        }, {
	            duration: 'slow',
	            queue: false,
	            complete: function () {
	                self.dragToPosition(self.initialPosition);
	            }
	        });
	};

	Drop.prototype.getCurrentPosition = function () {
	    if (!this.data.centered)
	        return new Point().fromPositionToZoomPosition(this.$element.position());

	    // WHY When centering a drop we apply 'auto' to the 'margin-left' and 'margin-right' properties.
	    // For an element that is positioned absolute automargin does not work unless you set 'left'
	    // and 'right' to '0'. Unfortunately this means when calling position() on $element we will
        // get the wrong 'left' value
	    var leftMargin = (this.$element.parent().innerWidth() - this.$element.width()) / 2;
	    return new Point(leftMargin, this.$element.position().top);
	};

    Drop.prototype.setZoomLevel = function (value) {
        Drop.zoomlevel = value;
    };
    Drop.prototype.getZoomLevel = function () {
        return Drop.zoomlevel;
    };
	Drop.prototype.getCurrentSize = function () {
	    return new Point(this.$element.width(), this.$element.height());
	};

    Drop.prototype.dragToPosition = function (newPos) {
	    var centered = this.data.centered;
	    /*var $parent = this.$element.offsetParent();
	    var position = this.$element.position();*/

	    var oldLeft = this.data.position.x;//position.left / scalePercentage;
	    var newLeft = newPos.x;// + $parent.scrollLeft();
	    var oldTop = this.data.position.y;//position.top / scalePercentage;
	    var newTop = newPos.y;// + $parent.scrollTop();
		

		if (newLeft < this.offsetLeft) {
			newLeft = this.offsetLeft;
		}
		if (newLeft + this.$element[0].offsetWidth > this.poolWidth + this.offsetLeft) {
			newLeft = this.poolWidth - this.$element[0].offsetWidth + this.offsetLeft;
		}

		if (newTop < this.offsetTop) {
			newTop = this.offsetTop;
		}
		if (newTop + this.$element[0].offsetHeight > this.poolHeight + this.offsetTop) {
			newTop = this.poolHeight - this.$element[0].offsetHeight + this.offsetTop;
		}

	    this.data.position = new Point(centered ? oldLeft : newLeft, newTop);

	    if (this.data.top !== null && this.data.top !== undefined) {
	        this.data.top = newTop;
	    }

	    if (this.data.bottom !== null && this.data.bottom !== undefined) {
	        this.data.bottom = this.data.bottom - (newTop - oldTop);
	    }

		if (this.data.left !== null && this.data.left !== undefined) {
			this.data.left = newLeft;
		}

		if (this.data.right !== null && this.data.right !== undefined) {
			this.data.right = this.data.right - (newLeft - oldLeft);
		}

	    if (this.anchor) {
	        this.anchor.top = this.data.top;
	        this.anchor.bottom = this.data.bottom;
	        this.anchor.left = this.data.left;
	        this.anchor.right = this.data.right;
        }

	    this.applyPosition();

        if (this.updatePositionIndicator)
            this.updatePositionIndicator();

        if (this.triggerDropMoved)
            this.triggerDropMoved();
    };

    // Do not use the pointer events.
    // Chrome 55 unified the mouse and pointer events api.
    // Since this change the code below assumes any device is a touch device on Chrome 55+.
    // There are some bugs in the code below on touch enabled devices, so we should
    // fix those first before enabling pointer events again.
    // https://developers.google.com/web/updates/2016/10/pointer-events

	/*var pointerEvents = {
		start: 'pointerdown',
		move: 'pointermove',
		end: 'pointerup',
		cancel: 'pointercancel'
	};*/

	/*var msPointerEvents = {
		start: 'mspointerdown',
		move: 'mspointermove',
		end: 'mspointerup',
		cancel: 'mspointercancel'
	};*/

	var touchEvents = {
		start: 'touchstart',
		move: 'touchmove',
		end: 'touchend',
		cancel: 'touchcancel'
	};

	//var mouseEvents = {
	//	start: 'mousedown',
	//	move: 'mousemove',
	//	end: 'mouseup',
	//	cancel: 'mousecancel'
	//};

    // for now only use touch events on touch-enabled devices

	/*var events = window.PointerEvent ? pointerEvents :
		window.navigator.msPointerEnabled ? msPointerEvents :
		touchEvents;*/
    var events = touchEvents;

	//document.body.ontouchstart !== undefined ? touchEvents :
	//mouseEvents;

	Drop.prototype.removeClicks = function () {
	    var $this = this.$element;
	    var settings = this.clickHandlers;
	    if (!settings) {
	        return;
	    }
	    $this.each(function (index, element) {
	        element.removeEventListener(events.start, settings.touchStartHandler, false);
	    });
	    $this.off('mousedown', settings.startHandler);
	    $this.removeClass('draggable');
	    delete this.clickHandlers;
	};

	Drop.prototype.clicks = function (options) {
		var _oldZIndex = 0;
		var dragging = false;
		var clickTimer = null;
		var clicks = 0;
		var offset;
		var startPos;
		var target;
		var $this;
		var $element;
		var self = this;
		var dropToDrag = self;
		var settings = $.extend(defaults(), options);

		self.removeClicks();

		self.clickHandlers = settings;

		$this = options.$target || self.$element;
		$element = $this;

		if (settings.drag) {
			$this.addClass('draggable');
			if (settings.dropToDrag) {
			    dropToDrag = settings.dropToDrag;
			    $element = settings.dropToDrag.$element;
			} else {
			    settings.dropToDrag = self;
			}
		}

		settings.touchStartHandler = function (e) {
		    if (!$(getTarget(e)).is(':input')) {
		        if (!onMouseDown(settings, e))
		            e.preventDefault(); // prevents mousemove event that would fire at the wrong time and place anyway
		    }
		};
		$this.each(function (index, element) {
		    element.addEventListener(events.start, settings.touchStartHandler, false);
		});
		settings.startHandler = function (e) { onMouseDown(settings, e); };
		$this.on('mousedown', settings.startHandler);

		var touchMoveHandler = function (e) {
			e.preventDefault();
			onMouseMove(settings, e);
		};

		function getPositionSource(e) {
            // we only support single touches for now
		    if (e.targetTouches && e.targetTouches.length) {
		        return e.targetTouches[0];
		    } else if (e.originalEvent && e.originalEvent.changedTouches && e.originalEvent.changedTouches.length) {
		        return e.originalEvent.changedTouches[0];
		    } else if (e.pageX) {
		        return e;
		    } else {
		        return e.originalEvent;
		    }
		}

		function getPosition(e) {
		    var source = getPositionSource(e);
		    var scalePercentage = Drop.zoomlevel || 1;
		    return new Point(Math.round(source.pageX / scalePercentage), Math.round(source.pageY / scalePercentage));
		}

		function getClientPosition(e) {
		    var source = getPositionSource(e);
		    var scalePercentage = Drop.zoomlevel || 1;
		    return new Point(Math.round(source.clientX / scalePercentage), Math.round(source.clientX / scalePercentage));
		}

		function getTarget(e) {
			var source;
			if (e.targetTouches && e.targetTouches.length) {
				source = e.targetTouches[0];
			} else {
				source = e;
			}
			return source.target;
		}

		var blockDragStart = function () { return false; };

		function onMouseDown(options, e) {

		    if (e.which === 2 || e.which === 3) { // Use event.which instead of event.button. http://api.jquery.com/event.which/
                // use reverse filtering because touch events don't have a button
		        return true;
		    }

		    target = getTarget(e);
		    if (settings.ignoreChildren && target !== $this[0]) {
		        return true;
		    }

			if (!["input", "select", "textarea", "button"].includes(document.activeElement.tagName)) {
				clicks++;
			} else {
				setTimeout(function () {
					self.triggerClick();
				}, 1);		  
			}

			if (clicks === 2) {
			    window.clearTimeout(clickTimer);
			}

			// prevent text selection (except for IE otherwise input text not selectable)
            if (!document.documentMode) {
			    document.onselectstart = function () { return false; };
			}

			startPos = getPosition(e);

			$this.on(events.end + ' ' + events.cancel, doClick);
			$this.on('mouseup', doClick);
			$(document).on(events.end + ' ' + events.cancel, endDrag);
			$(document).on('mouseup', endDrag);

			e.stopPropagation();

			if (!options.drag)
			    return;

			dropToDrag.initialPosition = util.cloneData(dropToDrag.data.position);

			var value = new Point().fromPosition($element.positionWithoutTransform());

			offset = value.subtract(startPos);

			document.body.addEventListener(events.move, touchMoveHandler);
		    // tell our code to start moving the element with the mouse
			$(document).on("mousemove.lq-drop-extensions-clicks", function (e) { onMouseMove(settings, e); });

			// cancel out any text selections
			document.body.focus();

			// prevent IE from trying to drag an image
			$this.on('dragstart', blockDragStart);

			// prevent text selection (except IE)
			return false;

		}

		function onMouseMove(options, e) {
			var position = getPosition(e);

			var xMove = (position.x - startPos.x);
			var yMove = (position.y - startPos.y);

			// if moved a bit => drag
			if (!dragging && Math.abs(xMove) + Math.abs(yMove) > 5) {

				options.beforeDrag(startPos);
				dragging = true;

				// disable the clickTimer
				clicks = 0;
				clearTimeout(clickTimer);

				// bring the clicked element to the front while it is being dragged
				_oldZIndex = $element.css('z-index');
				$element.css('z-index', 10000);
			}

			if (!dragging) {
			    return;
			}

			var pos = new Point(position.x, position.y);
			var adjustedStartPos = startPos;
			if (!options.dragIgnoreOffset) {
			    pos = pos.add(offset);
			    adjustedStartPos = startPos.add(offset);
			}

			if (typeof options.snapFunc === "function") {
			    pos = options.snapFunc(pos, adjustedStartPos);
			}
			options.dragFunc(pos, dropToDrag, target, adjustedStartPos, {
			    offset: offset,
			    xMove: xMove,
			    yMove: yMove,
			    clientPos: getClientPosition(e)
			});
		}

		function endDrag() {
		    $this.off('mouseup', doClick);
		    $this.off(events.end, doClick);
		    $(document).off(events.end + ' ' + events.cancel, endDrag);
		    $(document).off('mouseup', endDrag);

			if (settings.drag) {
				if (dragging) {
					dragging = false;
					$element.css('z-index', _oldZIndex);
					settings.afterDrag();
				}
				// we're done with these events until the next OnMouseDown
				$(document).off("mousemove.lq-drop-extensions-clicks");
				document.body.removeEventListener(events.move, touchMoveHandler);
				document.onselectstart = null;
				$this.off('dragstart', blockDragStart);
			}
		}

		self.triggerClick = function () {
			var position = $this.positionWithoutTransform();
		    var simulatedClickPosition = new Point().fromPosition(position);
		    settings.click(simulatedClickPosition, $this[0], new $.Event('click'));
		};

		function doClick(e) {
		    if (clicks === 1) {
		        var isTouch = e.type === events.end;
		        var timeout = isTouch ? 400 : 200;
				clickTimer =
						window.setTimeout(function () {
						    clicks = 0;
						    if (!dragging) {
						        var returnValue = settings.click(startPos, target, e);
						        if (returnValue && isTouch) {
						            // fire prevented mouse events in case someone needs them
						            var $target = $(target);
                                    $target.trigger('mousedown');
                                    $target.trigger('mouseup');
                                    $target.trigger('click');
						        }
						    }
						}, timeout);
			}

			if (clicks === 2) {
			    clicks = 0;
			    $this.off('mouseup', doClick);
			    $this.off(events.end, doClick);
			    $(document).off(events.end + ' ' + events.cancel, endDrag);
			    $(document).off('mouseup', endDrag);
				$(document).off("mousemove.lq-drop-extensions-clicks");
				document.body.removeEventListener(events.move, touchMoveHandler);
				if (!dragging)
				    settings.doubleClick(startPos, target);
			}
		}

		return this;
	};

});

